import React from 'react'

export default function IcoPlane( props ) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      { ...props }
    >
      <path d="M2.5 13.5l19-8c.6-.2.9.5.4.9l-4.1 3.3c-.3.2-.4.6-.3 1l1 5.6c.1.5-.5.8-.8.4l-3-3.3-2.6 2.1c-.3.3-.8 0-.7-.4l.5-3.1-9-.9c-.6-.1-.6-1-.1-1.2z" />
    </svg>
  )
}
